/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MtFileType {
    TEXT = 'TEXT',
    DELIMITED_TEXT = 'DELIMITED_TEXT',
    MARKUP = 'MARKUP',
    LOCALIZATION = 'LOCALIZATION',
    WORD = 'WORD',
    EXCEL = 'EXCEL',
    POWERPOINT = 'POWERPOINT',
    OPEN_DOCUMENT = 'OPEN_DOCUMENT',
    RICH_TEXT = 'RICH_TEXT',
    PDF = 'PDF',
    IMAGE = 'IMAGE',
    EMAIL = 'EMAIL',
}
